import { InjectionToken } from '@angular/core';
import { ReviewRateContainerComponent } from '../review-rate-container/review-rate-container.component';

export const REVIEW_RATE_CONTAINER = new InjectionToken<ReviewRateContainerComponent>('REVIEW_RATE_CONTAINER');
